import { OAuthProvider } from './OAuthProvider.types';

export function getTriggerURI(providerName: string | null): string {
    if (!providerName) {
        return '';
    }
    return `${window.location.origin}/Account/OpenId/${providerName}`;
}
